import React, { useState, useEffect } from 'react';
import Modal, { ModalDirectionOptions } from '../../components/Modal';
import { formatNumber } from '../../Resus/medicationUtils';
import { useTranslation } from 'react-i18next';

interface DefibrillatorConfirmationDialogProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  defaultJoules: number;
  onConfirm: (joules: number) => void;
}

const DefibrillatorConfirmationDialog: React.FC<DefibrillatorConfirmationDialogProps> = ({
  isOpen,
  setIsOpen,
  defaultJoules,
  onConfirm,
}) => {
  const [joules, setJoules] = useState<string>('');
  const { t } = useTranslation(['resus']);

  useEffect(() => {
    if (isOpen) {
      setJoules(defaultJoules.toString());
    }
  }, [isOpen, defaultJoules]);

  const formatInputValue = (value: string): string => {
    if (value === '') return '';
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return '';
    return formatNumber(numValue);
  };

  const handleValueChange = (value: string) => {
    setJoules(value);
  };

  const handleBlur = () => {
    setJoules(formatInputValue(joules));
  };

  const handleConfirm = () => {
    const numericValue = parseFloat(formatInputValue(joules));
    if (!isNaN(numericValue)) {
      onConfirm(numericValue);
    }
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t('defibrillator.confirmShock')}
      direction={ModalDirectionOptions.RTL}
      primaryButton={{
        text: t('buttons.confirm'),
        onClick: handleConfirm,
      }}
      secondaryButton={{
        text: t('buttons.cancel'),
        onClick: () => setIsOpen(false),
      }}
    >
      <div style={{ textAlign: 'right', direction: 'rtl' }}>
        <div style={{ marginBottom: '20px' }}>
          {t('defibrillator.changeShockStrength')}
        </div>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '10px'
        }}>
          <div style={{ width: '120px', flexShrink: 0 }}>
            {t('defibrillator.strength')} (joules):
          </div>
          <input
            type="number"
            value={joules}
            onChange={(e) => handleValueChange(e.target.value)}
            onFocus={(e) => e.target.select()}
            onBlur={handleBlur}
            step="1"
            style={{
              width: '120px',
              padding: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DefibrillatorConfirmationDialog;